import React from 'react';

import { Box, Typography } from '@material-ui/core';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import useStyles from './styles';

export interface CategoryLabelProps {
  name: string;
  bgColor?: string;
  textColor?: string;
  wrapperClass?: string;
  textClass?: string;
  url?: string | null;
  withDots?: boolean;
  textMaxWidth?: number;
}

const CategoryLabel: React.FC<CategoryLabelProps> = ({
  name,
  bgColor,
  textColor,
  wrapperClass = '',
  textClass = '',
  url = '',
  withDots = true,
  textMaxWidth,
}) => {
  const classes = useStyles(bgColor, textColor, textMaxWidth)();

  if (url) {
    return (
      <Link className={cx(classes.categoryLabel, wrapperClass)} to={url}>
        <Typography className={cx(classes.categoryTitle, textClass, withDots && classes.withDots)}>
          {name}
        </Typography>
      </Link>
    );
  }

  return (
    <Box className={cx(classes.categoryLabel, wrapperClass)}>
      <Typography className={cx(classes.categoryTitle, textClass, withDots && classes.withDots)}>
        {name}
      </Typography>
    </Box>
  );
};

export default CategoryLabel;
